import React from 'react';
import { Button } from './ui/Button';
import { Mail, Phone } from 'lucide-react';
import { motion } from 'framer-motion';
export function ContactSection() {
  return <section id="contact" className="relative py-24 bg-earth-900" data-id="element-27">
      <div className="absolute inset-0 bg-grain opacity-20 pointer-events-none mix-blend-overlay" data-id="element-28"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-30">
          <h2 className="font-serif text-4xl md:text-5xl text-cream-50 mb-4" data-id="element-31">
            Ready to Begin Your Next Chapter?
          </h2>
          <p className="text-xl text-cream-50/70 mb-12" data-id="element-32">
            Let's connect. Every message is confidential.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-12" data-id="element-33">
            <a href="tel:+31630303225" className="flex items-center space-x-3 text-gold-400 hover:text-white transition-colors group" data-id="element-34">
              <div className="w-12 h-12 rounded-full bg-gold-400/10 flex items-center justify-center group-hover:bg-gold-400/20 transition-colors" data-id="element-35">
                <Phone size={20} data-id="element-36" />
              </div>
              <span className="text-lg font-medium" data-id="element-37">+31 6 30303225</span>
            </a>

            <a href="mailto:mark.vermeulen90@gmail.com" className="flex items-center space-x-3 text-gold-400 hover:text-white transition-colors group" data-id="element-38">
              <div className="w-12 h-12 rounded-full bg-gold-400/10 flex items-center justify-center group-hover:bg-gold-400/20 transition-colors" data-id="element-39">
                <Mail size={20} data-id="element-40" />
              </div>
              <span className="text-lg font-medium" data-id="element-41">
                mark.vermeulen90@gmail.com
              </span>
            </a>
          </div>

          <Button variant="primary" className="text-xl px-10 py-4 shadow-lg shadow-gold-400/20" data-id="element-42">
            Book a Free Discovery Call
          </Button>
        </motion.div>
      </div>
    </section>;
}